import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.getcommissionSettingData = function (state, payload) {
  var rows = SysUtils.cloneObject(state.commissionSettingData)
  state.commissionSettingData = []
  if (!SysUtils.existsKey(payload, 'id')) {
    state.commissionSettingData = payload
  } else {
    state.commissionSettingData = rows
    state.commissionSettingData[payload.index].noEdit = payload.noEdit
    state.commissionSettingData[payload.index].question_amount = rows[payload.index].question_amount
    state.commissionSettingData[payload.index].commission_amount = rows[payload.index].commission_amount
  }
}

const state = {
  commissionSettingData: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        getcommissionSettingData: {api: 'M0301CommissionSettingService.searchcommissionDetails'}
      }
    }

    return client.postData(ctx)
      .then((data) => {
        if (SysUtils.isEmpty(data.getcommissionSettingData.output)) {
          alert('no match record')
        }
        commit('getcommissionSettingData', data.getcommissionSettingData.output)
      })
  },
  saveEditRow: ({ commit, state }, row) => {
    console.debug('called M0203Question saveQuestionWithAns')
    return client.postData({ data: { saveEditRow: { api: 'M0301CommissionSettingService.saveNewcommissionSetting', input: row } } })
      .then((data) => {
        commit('getcommissionSettingData', data.saveEditRow.output)
      })
  }/*
  deleteRow: ({ commit, state }, row) => {
    console.debug('called M0203Question saveQuestionWithAns')
    return client.postData({ data: { deleteRow: { api: 'M0301CommissionSettingService.deletecommissionSetting', input: row } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.getcommissionSettingData.output)) {
          alert('no match record')
        }
        commit('getcommissionSettingData', data.deleteRow.output)
      })
  } */
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0301CommissionSetting/M0301CommissionSettingStore.js